export default "__VITE_ASSET__64892744__"